var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.40771V20.6284C16.875 21.6655 16.0371 22.5034 15 22.5034C13.9629 22.5034 13.125 21.6655 13.125 20.6284V6.40771L8.82422 10.7085C8.0918 11.4409 6.90234 11.4409 6.16992 10.7085C5.4375 9.97607 5.4375 8.78661 6.16992 8.05419L13.6699 0.554199C14.4023 -0.178222 15.5918 -0.178222 16.3242 0.554199L23.8242 8.05419C24.5566 8.78661 24.5566 9.97607 23.8242 10.7085C23.0918 11.4409 21.9023 11.4409 21.1699 10.7085L16.875 6.40771ZM3.75 20.6284H11.25C11.25 22.6968 12.9316 24.3784 15 24.3784C17.0684 24.3784 18.75 22.6968 18.75 20.6284H26.25C28.3184 20.6284 30 22.31 30 24.3784V26.2534C30 28.3218 28.3184 30.0034 26.25 30.0034H3.75C1.68164 30.0034 0 28.3218 0 26.2534V24.3784C0 22.31 1.68164 20.6284 3.75 20.6284ZM25.3125 26.7221C25.6855 26.7221 26.0431 26.574 26.3069 26.3103C26.5706 26.0465 26.7188 25.6889 26.7188 25.3159C26.7188 24.9429 26.5706 24.5853 26.3069 24.3215C26.0431 24.0578 25.6855 23.9096 25.3125 23.9096C24.9395 23.9096 24.5819 24.0578 24.3181 24.3215C24.0544 24.5853 23.9062 24.9429 23.9062 25.3159C23.9062 25.6889 24.0544 26.0465 24.3181 26.3103C24.5819 26.574 24.9395 26.7221 25.3125 26.7221Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.5db111b4151b5bd64406f1d9908dfcd7.svg";
export { ForwardRef as ReactComponent };